import { render, staticRenderFns } from "./DrawerSignUp.vue?vue&type=template&id=6a1317b4&scoped=true"
import script from "./DrawerSignUp.vue?vue&type=script&lang=js"
export * from "./DrawerSignUp.vue?vue&type=script&lang=js"
import style0 from "./DrawerSignUp.vue?vue&type=style&index=0&id=6a1317b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1317b4",
  null
  
)

export default component.exports